(ns frontend.ui.page.fund.model
  (:require
   [common.endpoints.lp-portal.model :as endpoint-model]
   [malli.core :as m]))

(def root-path [:views :fund-reports])

(defn fund-path
  [fund-id]
  (into root-path [:by-fund fund-id]))

(defn report-state
  [db fund-id]
  (get-in db (fund-path fund-id) {:loading? true}))

(defn start-load
  [db {:keys [fund-id request-id]}]
  (assoc-in db (fund-path fund-id)
            {:request-id request-id
             :loading? true
             :reports []}))

(defn stop-reporting-path
  [fund-id]
  (into root-path [:stop-reporting fund-id]))

(defn close-stop-reporting
  [db fund-id]
  (update-in db (conj root-path :stop-reporting) dissoc fund-id))

(defn close
  [db fund-id]
  (-> db
      (update-in (conj root-path :by-fund) dissoc fund-id)
      (close-stop-reporting fund-id)))

(defn- settle
  [db {:keys [fund-id request-id reports reporting error]}]
  (let [state (report-state db fund-id)]
    (if (and (:loading? state)
             (some? request-id)
             (= request-id (:request-id state)))
      (assoc-in db (fund-path fund-id)
                {:request-id request-id
                 :loading? false
                 :reports (vec reports)
                 :reporting reporting
                 :error error})
      db)))

(defn loaded
  [db {:keys [response] :as request}]
  (if (m/validate endpoint-model/fund-reports-response response)
    (let [body (:body response)]
      (settle db (assoc request
                        :reports (:reports body)
                        :reporting (select-keys body [:reporting-discontinued?
                                                      :unfinished-reports?
                                                      :blocking-master-funds
                                                      :feeder-master-funds]))))
    (settle db (assoc request :error :invalid-response))))

(defn failed
  [db request]
  (settle db (assoc request :error (or (:error request) :request-failed))))

(defn report-items
  [db fund-id]
  (->> (report-state db fund-id)
       :reports
       (mapv (fn [report]
               {:id (:db/id report)
                :title (:lp-report/title report)
                :step (:lp-report/step report)}))))

(defn state->reporting
  "The discontinuation state of the fund from its report state. The backend
   sends the blockers only to a reporting admin."
  [state]
  (:reporting state))

(defn reporting
  [db fund-id]
  (state->reporting (report-state db fund-id)))

(defn discontinue-blocker
  "The reason why the fund reporting cannot be discontinued, or nil. An
   unfinished master report comes first, because it is in another fund."
  [{:keys [blocking-master-funds unfinished-reports?]}]
  (cond
    (seq blocking-master-funds) {:blocker      :master-fund-reports
                                 :master-funds blocking-master-funds}
    unfinished-reports?         {:blocker :unfinished-reports}))

(defn lp-report-header-state
  "What the Fund reports module shows in its header and empty state."
  [{:keys [reporting reporting-admin?]}]
  (let [discontinued? (boolean (:reporting-discontinued? reporting))
        active-admin? (boolean (and reporting-admin? (not discontinued?)))]
    {:discontinued?    discontinued?
     :can-add-reports? active-admin?
     ;; The backend sends the blockers only to a reporting admin. Without
     ;; them the state is not loaded yet, so do not show the menu.
     :show-menu?       (and active-admin?
                            (contains? reporting :unfinished-reports?))
     :blocker          (discontinue-blocker reporting)}))

;; The user must check every statement before the dialog lets them confirm.
(def stop-reporting-confirmations
  [:stop-new-reports
   :archive-access
   :no-undo])

(defn open-stop-reporting
  [db fund-id]
  (assoc-in db (stop-reporting-path fund-id) {:confirmed #{}}))

(defn toggle-stop-reporting-confirmation
  [db {:keys [fund-id confirmation checked?]}]
  (if (get-in db (stop-reporting-path fund-id))
    (update-in db
               (conj (stop-reporting-path fund-id) :confirmed)
               (if checked? conj disj)
               confirmation)
    db))

(defn stop-reporting-dialog
  "The dialog state, or nil when the dialog is closed."
  [db fund-id]
  (when-let [{:keys [confirmed]} (get-in db (stop-reporting-path fund-id))]
    {:confirmed      confirmed
     :all-confirmed? (= (set stop-reporting-confirmations) confirmed)}))
